import React, { createContext } from 'react'
import ListingServices from '../Services/Consumers/ListingServices'
import { FormattedMessage, useIntl } from 'react-intl'

const LateSubmissionContext = createContext({})

const LateSubmissionProvider = ({ children }) => {
  const intl = useIntl()
  const [lateSubmissionReasons, setLateSubmissionReasons] = React.useState([])
  const [lateSubmissionReasonsLoading, setLateSubmissionReasonsLoading] = React.useState(false)
  const [lateSubmissionConf, setLateSubmissionConf] = React.useState({})
  const [lateSubmissionConfLoading, setLateSubmissionConfLoading] = React.useState(false)
  const getLateSubmissionReasons = (event) => {
    setLateSubmissionReasonsLoading(true)
    ListingServices.getLateSubmissionReasons(<FormattedMessage
      id='getLateSubmissionReasons.FormErrorAlert'/>).then((result) => {
      if (!!result && !!result?.data) {
        setLateSubmissionReasons(result?.data?.map(reason => ({
          key: reason?.id,
          name_en: reason?.nameEn,
          name_ar: reason?.nameAr
        })))
      }
    }).then(() => {
      setLateSubmissionReasonsLoading(false)
    })
  }

  React.useEffect(() => {
      setLateSubmissionConfLoading(true)
      ListingServices.getSPConfigData(intl.formatMessage({ id: `getSPLateSubmissionConfigData.Error` })
      ).then((result) => {
        if (!!result && !!result.data) {
          setLateSubmissionConf(result.data)
        }
      }).then(() => {
        setLateSubmissionConfLoading(false)
      })
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  return (
    <LateSubmissionContext.Provider value={{
      lateSubmissionConf,
      lateSubmissionConfLoading,
      lateSubmissionReasons,
      lateSubmissionReasonsLoading,
      getLateSubmissionReasons
    }}>
      {children}
    </LateSubmissionContext.Provider>
  )
}
const LateSubmissionConsumer = LateSubmissionContext.Consumer

export { LateSubmissionContext, LateSubmissionProvider, LateSubmissionConsumer }
